import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderQuestions from "./useReorderQuestions";
import { txt } from "../../../services/translation";

export default function useDeleteQuestion(){

    const {quizId} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', quizId, 'questions'], [quizId]);

    const reorderQuestions = useReorderQuestions()

    return (id) => {

        const ok = window.confirm(txt('confirmDeleteQuestion'));

        if(!ok) return false;
        
        const oldQuestions = [...queryClient.getQueryData(queryKey)];

        let newQuestions = [...queryClient.getQueryData(queryKey)].filter(c => c.id !== id);
        newQuestions = reorderQuestions(newQuestions);
        queryClient.setQueryData(queryKey, newQuestions);

        API.delete(`/design/questions/${id}`)
            .then(() => API.put('/design/questions/reorder', newQuestions))
            .catch(() => {
                queryClient.setQueryData(queryKey, oldQuestions)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}